import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/env-provider.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next-runtime-env/build/provider/use-env-context.js");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/circleci/project/packages/builder/clientUtils.tsx");
;
import(/* webpackMode: "eager" */ "/home/circleci/project/packages/core-events/src/search/SearchEventEmitter.tsx");
